import WATERMARK from '../../APP/helper/WATERMARK.js';
/** An Application Controller Class
    @description Constructs the Application and initializes the MAIN Element
    This should be instantiated during the init phase of the html document
*/
export default class CONTROLLER {
    page;
    config;
    watermark;
    url;
    constructor(page, config) {
        this.page = page;
        this.config = config;
        this.watermark = new WATERMARK();
        this.url = new URL(window.location.href);
    }
}
